// Curated WHO ICD-10 codes for NHCX diagnosis autocomplete.
// ABDM specifies ICD-10 (not ICD-11). Code and display are paired here so the
// form never sends a mismatch — the API does not check that they agree.
// Search is local (code or display). The sandbox example I20.0 is first.

export const ICD10_CATALOG = [
  { code: "I20.0", display: "Unstable angina" },
  { code: "I20.1", display: "Angina pectoris with documented spasm" },
  { code: "I20.8", display: "Other forms of angina pectoris" },
  { code: "I20.9", display: "Angina pectoris, unspecified" },
  { code: "I21.0", display: "Acute transmural myocardial infarction of anterior wall" },
  { code: "I21.1", display: "Acute transmural myocardial infarction of inferior wall" },
  { code: "I21.9", display: "Acute myocardial infarction, unspecified" },
  { code: "I25.1", display: "Atherosclerotic heart disease" },
  { code: "I25.2", display: "Old myocardial infarction" },
  { code: "I10", display: "Essential (primary) hypertension" },
  { code: "I11.0", display: "Hypertensive heart disease with (congestive) heart failure" },
  { code: "I50.0", display: "Congestive heart failure" },
  { code: "I50.9", display: "Heart failure, unspecified" },
  { code: "I48.9", display: "Atrial fibrillation and flutter, unspecified" },
  { code: "I63.9", display: "Cerebral infarction, unspecified" },
  { code: "I64", display: "Stroke, not specified as haemorrhage or infarction" },
  { code: "E11.9", display: "Type 2 diabetes mellitus without complications" },
  { code: "E11.5", display: "Type 2 diabetes mellitus with peripheral circulatory complications" },
  { code: "E10.9", display: "Type 1 diabetes mellitus without complications" },
  { code: "E66.9", display: "Obesity, unspecified" },
  { code: "N18.9", display: "Chronic kidney disease, unspecified" },
  { code: "N17.9", display: "Acute kidney failure, unspecified" },
  { code: "N39.0", display: "Urinary tract infection, site not specified" },
  { code: "J18.9", display: "Pneumonia, unspecified" },
  { code: "J44.1", display: "Chronic obstructive pulmonary disease with acute exacerbation" },
  { code: "J45.9", display: "Asthma, unspecified" },
  { code: "J06.9", display: "Acute upper respiratory infection, unspecified" },
  { code: "K35.8", display: "Acute appendicitis, other and unspecified" },
  { code: "K80.2", display: "Calculus of gallbladder without cholecystitis" },
  { code: "K80.0", display: "Calculus of gallbladder with acute cholecystitis" },
  { code: "K92.2", display: "Gastrointestinal haemorrhage, unspecified" },
  { code: "K29.7", display: "Gastritis, unspecified" },
  { code: "K21.0", display: "Gastro-oesophageal reflux disease with oesophagitis" },
  { code: "K57.3", display: "Diverticular disease of large intestine without perforation or abscess" },
  { code: "K40.9", display: "Unilateral or unspecified inguinal hernia, without obstruction or gangrene" },
  { code: "K42.9", display: "Umbilical hernia without obstruction or gangrene" },
  { code: "K43.9", display: "Ventral hernia without obstruction or gangrene" },
  { code: "K56.7", display: "Ileus, unspecified" },
  { code: "K85.9", display: "Acute pancreatitis, unspecified" },
  { code: "N20.0", display: "Calculus of kidney" },
  { code: "N20.1", display: "Calculus of ureter" },
  { code: "N40", display: "Hyperplasia of prostate" },
  { code: "C50.9", display: "Malignant neoplasm of breast, unspecified" },
  { code: "C16.9", display: "Malignant neoplasm of stomach, unspecified" },
  { code: "C18.9", display: "Malignant neoplasm of colon, unspecified" },
  { code: "C34.9", display: "Malignant neoplasm of bronchus or lung, unspecified" },
  { code: "C61", display: "Malignant neoplasm of prostate" },
  { code: "C22.0", display: "Liver cell carcinoma" },
  { code: "D64.9", display: "Anaemia, unspecified" },
  { code: "D50.9", display: "Iron deficiency anaemia, unspecified" },
  { code: "A09", display: "Other gastroenteritis and colitis of infectious and unspecified origin" },
  { code: "A41.9", display: "Sepsis, unspecified" },
  { code: "B34.9", display: "Viral infection, unspecified" },
  { code: "S72.0", display: "Fracture of neck of femur" },
  { code: "S72.3", display: "Fracture of shaft of femur" },
  { code: "S82.2", display: "Fracture of shaft of tibia" },
  { code: "S52.5", display: "Fracture of lower end of radius" },
  { code: "S42.2", display: "Fracture of upper end of humerus" },
  { code: "S06.0", display: "Concussion" },
  { code: "S06.9", display: "Intracranial injury, unspecified" },
  { code: "M17.9", display: "Gonarthrosis, unspecified" },
  { code: "M16.9", display: "Coxarthrosis, unspecified" },
  { code: "M51.2", display: "Other specified intervertebral disc displacement" },
  { code: "M54.5", display: "Low back pain" },
  { code: "M25.5", display: "Pain in joint" },
  { code: "M79.1", display: "Myalgia" },
  { code: "G40.9", display: "Epilepsy, unspecified" },
  { code: "G43.9", display: "Migraine, unspecified" },
  { code: "G20", display: "Parkinson's disease" },
  { code: "H25.9", display: "Senile cataract, unspecified" },
  { code: "H40.9", display: "Glaucoma, unspecified" },
  { code: "O80", display: "Single spontaneous delivery" },
  { code: "O82", display: "Single delivery by caesarean section" },
  { code: "O34.2", display: "Maternal care due to uterine scar from previous surgery" },
  { code: "N81.4", display: "Uterovaginal prolapse, unspecified" },
  { code: "N80.9", display: "Endometriosis, unspecified" },
  { code: "N70.9", display: "Salpingitis and oophoritis, unspecified" },
  { code: "L03.9", display: "Cellulitis, unspecified" },
  { code: "L89.9", display: "Decubitus ulcer and pressure area, unspecified" },
  { code: "T81.4", display: "Infection following a procedure, not elsewhere classified" },
  { code: "Z38.0", display: "Singleton, born in hospital" },
  { code: "Z51.1", display: "Chemotherapy session for neoplasm" },
  { code: "R10.4", display: "Other and unspecified abdominal pain" },
  { code: "R07.4", display: "Chest pain, unspecified" },
  { code: "R50.9", display: "Fever, unspecified" },
  { code: "R55", display: "Syncope and collapse" },
  { code: "R06.0", display: "Dyspnoea" },
];

export function searchIcd10(query) {
  const q = String(query || "").trim().toLowerCase();
  if (q.length < 1) return [];
  return ICD10_CATALOG.filter(
    (row) =>
      row.code.toLowerCase().includes(q) || row.display.toLowerCase().includes(q)
  ).slice(0, 40);
}
